import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

@Component({
    selector: 'app-how-it-works',
    templateUrl: './how-it-works.component.html',
    styleUrls: ['./how-it-works.component.scss'],
    standalone: false
})
export class HowItWorksComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  parentType: any;

  constructor(public modalRef : BsModalRef, public languageTranslateService: LanguageTranslateService) {
    super();
   }

  ngOnInit(): void {
    this.getLanguageData();
  }
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      })
    );
  }

ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  push(obs: any) {
    super.push(obs);
  }
}